import { useMosaic } from "@/context/mosaic/MosaicContext";
import { useTabs } from "@/context/tabs/TabsContext";
import type { ViewId } from "@/shared/types/common";

export const useHandleTickerClick = (tileId: string) => {
	const { setClickInfo } = useMosaic();
	const { getWidgetState, setWidgetState } = useTabs();
	const state = getWidgetState(tileId as ViewId);

	const handleTickerClick = (
		event:
			| React.MouseEvent<Element, MouseEvent>
			| React.KeyboardEvent<HTMLTableCellElement>,
	) => {
		const ticker = (event.currentTarget as HTMLElement).dataset.rowId as string;

		setWidgetState(tileId as ViewId, { ...(state || {}), ticker: ticker });
		setClickInfo({ [tileId]: ticker });
	};

	return handleTickerClick;
};
